import { useCallback, useEffect, useState } from "react";
import PecasOutput from "../../models/pecas/PecasOutput";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaListaPecas = () => {
    const [listaPecas, setListaPecas] = useState(PecasOutput.create([]))

    const buscaListaPecas = useCallback(() => {
        http.get('/items')
            .then(res => {
                const resposta = res.data
                const listaPecas = PecasOutput.create(resposta)
                setListaPecas(listaPecas)
            })
            .catch(() => setListaPecas(PecasOutput.create([])))
    }, [])

    useEffect(() => {
        buscaListaPecas()
    }, [buscaListaPecas])

    useRecarregaAoRenovarToken(buscaListaPecas)

    return {
        listaPecas,
    }
}
